import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "rankings-list-title",
  class: "_mb-3"
}
const _hoisted_2 = {
  class: "_rounded--common _bxsh--base _flexcol _bgc--white",
  role: "list",
  "aria-labelledby": 'rankings-list-title'
}
const _hoisted_3 = ["href", "data-qa"]
const _hoisted_4 = { class: "_flexaicntr _as-fs _gap-1 gfu-ranking-list-media" }
const _hoisted_5 = { class: "gfu-ranking-list-media__icon" }
const _hoisted_6 = { class: "_fw-eb gfu-bt--b1" }
const _hoisted_7 = { class: "gfu-ranking-list-description" }
const _hoisted_8 = { class: "_flexcol _ov-h" }
const _hoisted_9 = {
  class: "_fw-eb gfu-bt--b1 _line-clamp-1",
  "data-qa": "project-name"
}
const _hoisted_10 = { class: "gfu-bt--caption _tc--lighter" }
const _hoisted_11 = { class: "_flexcol gfu-ranking-list-description__values" }
const _hoisted_12 = { class: "_tc--lighter gfu-bt--caption _ttu" }
const _hoisted_13 = {
  class: "_tc--dark gfu-bt--b1",
  "data-qa": "ranking-value"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_image = _resolveComponent("base-image")
  const _component_creators_line = _resolveComponent("creators-line")

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_icon, {
        name: $props.icon,
        "aria-hidden": "true"
      }, null, 8 /* PROPS */, ["name"]),
      _createTextVNode(" " + _toDisplayString($props.title), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: item.url,
          class: "_flexaicntr gfu-link--nofx _gap-2 _pa-2 _bdb--default _bc--disabled _pos-r gfu-ranking-list",
          role: "listitem",
          "data-qa": `ranking-entry:${index}`
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, "#" + _toDisplayString(index + 1), 1 /* TEXT */),
              (index < 3)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    name: "wreath-laurel-icon",
                    "icon-namespace": "ga",
                    size: "5x",
                    class: "_tc--light-gray _pos-a--cntr",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _createVNode(_component_base_image, {
              width: "64",
              height: "64",
              src: item.imageUrl,
              alt: item.name,
              loading: "lazy",
              class: "_rounded--common"
            }, null, 8 /* PROPS */, ["src", "alt"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_creators_line, {
                  creator: item.creator,
                  "co-creators": item.coCreators
                }, null, 8 /* PROPS */, ["creator", "co-creators"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(item.valueTitle), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_13, _toDisplayString(item.value), 1 /* TEXT */)
            ])
          ])
        ], 8 /* PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}